import Head from 'next/head';
import { IMediaBox, staticTitle } from '#config';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';

type DescriptionProps = {
  title?: string;
  description?: string;
  image?: string | { [ratio: string]: IMediaBox };
  type?: string;
};

type Props = {
  about?: DescriptionProps;
  type?: string;
  twitter?: { card?: 'summary' | 'summary_large_image' | 'app' | 'player' };
};

const removeMarkup = (code: string) => {
  const tagRegEx = /<\/?[\d\w-]+>/gm;
  return code?.replace(tagRegEx, '');
};

const DEFAULT_IMG = '/static/images/img/VEEJOY-Social.png';

const SocialMeta = ({ about, twitter }: Props) => {
  const { t } = useTranslation();
  const router = useRouter();

  const composedTitle = `${staticTitle}${about?.title}`;
  const img =
    typeof about.image === 'string'
      ? about.image
      : (about?.image?.['16_9'] || about?.image?.['16_7'])?.srcSet[0]?.replace(
          '1x',
          ''
        );

  return (
    <Head>
      <title key="htmlTitle">{composedTitle}</title>
      <meta
        name="description"
        content={
          removeMarkup(about?.description) || t('defaultMetaDescription')
        }
        key="metaDescription"
      />
      <meta property="og:title" content={composedTitle} key="metaOgTitle" />
      <meta
        property="og:url"
        content={'/' + router.locale + router.asPath}
        key="metaOgUrl"
      />
      <meta
        property="og:type"
        content={about.type ?? 'website'}
        key="metaOgType"
      />
      <meta
        property="og:image"
        content={String(img || DEFAULT_IMG).trim()}
        key="metaOgImg"
      />
      <meta property="og:image:width" content="853" />
      <meta property="og:image:height" content="480" />
      <meta
        property="og:description"
        content={
          removeMarkup(about?.description) || t('defaultMetaDescription')
        }
        key="metaOgDescription"
      />
      <meta
        name="twitter:card"
        content={twitter?.card || 'summary_large_image'}
        key="metaTwitterCard"
      />
    </Head>
  );
};

export default SocialMeta;
